export default "__VITE_ASSET__Xj0ME9hl__"